import { AxiosError } from 'axios';
import RequestHelper from '../apis/RequestHelper';

export default async function checkSession() {
  const userInfo = JSON.parse(localStorage.getItem('user_info') || '{}');
  if (userInfo && userInfo.sub) {
    try {
      const res = await RequestHelper.nonCasCatchResponse.get('/users/checkSession');
      if (res && res.data && res.data.isActive) {
        window.location.href = '/';
      } else {
        localStorage.removeItem('id_token');
        localStorage.removeItem('user_info');
      }
    } catch (error) {
      if (error && error instanceof AxiosError && error.response && error.response.status === 401) {
        localStorage.removeItem('id_token');
        localStorage.removeItem('user_info');
      }
    }
  }
}